<template>
  <div>
    <el-button-group v-if="!isViewDisabled">
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-edit"
        @click="add()"
        class="mb-2"
        >{{ $l("form_add_btn") || "新增" }}</el-button
      >
    </el-button-group>
    <!-- 表格-->
    <el-table
      :data="tableData"
      stripe
      size="small"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column
        :label="$l('table_label_operation') || '操作'"
        width="80"
        align="center"
        v-if="!isViewDisabled"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            style="padding: 5px"
            icon="el-icon-edit-outline"
            @click="update(scope.row)"
          ></el-button>
          <el-button
            size="mini"
            style="padding: 5px"
            type="danger"
            :disabled="scope.row.contactStatusText === '无效'"
            @click="del(scope.row)"
            icon="el-icon-delete"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="seqno"
        :label="$l('conact_table_label_sortorder') || '排序'"
        width="50"
      >
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="center"
        prop="contactName"
        :label="$l('conact_table_label_name') || '姓名'"
        width="100"
      >
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        header-align="center"
        prop="contactJob"
        :label="$l('conact_table_label_position') || '职位'"
        width="150"
      >
      </el-table-column>

      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        header-align="center"
        prop="contactMobile"
        :label="$l('conact_table_label_mobile_phone') || '移动电话'"
        width="150"
      >
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="center"
        prop="contactPhone"
        :label="$l('conact_table_label_office_phone') || '办公电话'"
        width="190"
      >
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="center"
        prop="contactEmail"
        :label="$l('conact_table_label_email') || '邮箱'"
        min-width="200"
      >
      </el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        prop="contactDefaultFlag"
        :label="$l('conact_table_label_default_contact') || '默认联系人'"
        min-width="80"
      >
        <template slot-scope="scope">
          <el-tag
            size="mini"
            :type="
              scope.row.contactDefaultFlagText === '是' ? 'success' : 'danger'
            "
            >{{ scope.row.contactDefaultFlagText }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        prop="contactStatus"
        :label="$l('conact_table_label_status') || '状态'"
        min-width="80"
      >
        <template slot-scope="scope">
          <el-tag
            size="mini"
            :type="
              scope.row.contactStatusText === '有效' ? 'success' : 'danger'
            "
            >{{ scope.row.contactStatusText }}</el-tag
          >
        </template>
      </el-table-column>
      <!-- <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l("INDEX.tips_no_data") || "暂无数据！" }}</p>
        </div>
      </div> -->
    </el-table>
    <!--分页-->
    <template>
      <div class="d-flex flex-row-reverse mt-3">
        <el-pagination
          background
          :current-page="params.curPage"
          :page-size="params.pageSize"
          :total="total"
          @size-change="sizeChange"
          @current-change="currentChange"
          layout="total, sizes, prev, pager, next, jumper, ->, slot"
        >
        </el-pagination>
      </div>
    </template>
    <el-dialog
      @opened="dialogOpened"
      @closed="dialogClosed"
      title="联系人修改"
      :visible.sync="dialogVisible1"
      width="800px"
    >
      <ContactsDetail
        ref="contactsDetail"
        @back="back"
        @getData="getData"
      ></ContactsDetail>
    </el-dialog>
  </div>
</template>
<script>
import ContactsDetail from "./detail/contactsDetail";

export default {
  props: {
    height: {
      default: 350,
      type: Number,
    },
  },
  components: {
    ContactsDetail,
  },
  data() {
    return {
      dialogVisible1: false,
      isViewDisabled: false,
      tableData: [],
      formData: {},
      params: {
        curPage: 1,
        pageSize: 10,
        scmCode: "",
      },
      total: 0,
    };
  },
  methods: {
    init(scmCode, isViewDisabled) {
      this.params.scmCode = scmCode;
      this.isViewDisabled = isViewDisabled;
      this.getData();
    },
    reset() {
      this.dialogVisible1 = false;
      this.isViewDisabled = false;
      this.tableData = [];
      this.formData = {};
      this.params = {
        curPage: 1,
        pageSize: 10,
        scmCode: "",
      };
      this.getData();
    },
    getData() {
      this.$api.scmInfoContactsListApi(this.params).then((res) => {
        this.total = res.body.count;
        this.params.curPage = res.body.curPage;
        this.params.pageSize = res.body.pageSize;
        this.tableData = res.body.data;
      });
    },
    dialogOpened() {
      this.$refs.contactsDetail.init(this.formData);
    },
    dialogClosed() {
      this.getData();
    },
    add() {
      this.formData = {
        type: "add",
        scmCode: this.params.scmCode,
        contactNameCardUrl1: "",
        contactNameCardUrl2: "",
        contactDefaultFlag: "N",
      };
      this.dialogVisible1 = true;
    },
    update(row) {
      let strRow = JSON.stringify(row);
      this.formData = JSON.parse(strRow);
      this.formData.type = "update";
      this.dialogVisible1 = true;
    },
    save() {
      this.dialogVisible1 = false;
    },
    del(row) {
      this.$confirm("确定要删除“" + row.contactName + "”吗？", "提示")
        .then(() => {
          this.$api
            .scmInfoContactsUpdateStatusApi({
              scmCode: row.scmCode,
              seqno: row.seqno,
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "删除成功 ",
              });
              this.getData();
            });
        })
        .catch(() => {});
    },
    back() {
      this.dialogVisible1 = false;
    },
    sizeChange(val) {
      this.params.curPage = 1;
      this.params.pageSize = val;
      this.getData();
    },
    currentChange(val) {
      this.params.curPage = val;
      this.getData();
    },
  },
};
</script>
